"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const generateFocusedImageAlt = focusedImage => {
  // runs through each of the possible alt text sources for a focused image
  if (focusedImage) {
    return focusedImage?.alt ? focusedImage?.alt : focusedImage?.altText ? focusedImage?.altText : focusedImage?.title ? focusedImage?.title : focusedImage?.focalPointImage?.title ? focusedImage?.focalPointImage?.title : "";
  }
};
var _default = generateFocusedImageAlt;
exports.default = _default;